var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.502a5 5 0 1 0-10 0 5 5 0 0 0 10 0m-.966 5.097A6.499 6.499 0 0 1 2 8.502c0-3.59 2.909-6.5 6.5-6.5a6.499 6.499 0 0 1 5.096 10.534l4.185 4.185a.75.75 0 0 1-1.06 1.06z"
  })));
};
export default SvgSearch;